import {
  InputBase,
  InputBaseProps,
  SxProps,
  Theme,
  styled,
} from "@mui/material";

const TextInputContainer = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  borderRadius: 20,
  backgroundColor: "white",
  padding: theme.spacing(0, 2),
}));

const IconContainer = styled("div")(({ theme }) => ({
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  height: "100%",
  flex: 1,
}));

const TextInput = (props: {
  ariaLabel: string;
  sx?: SxProps<Theme>;
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
  inputProps?: InputBaseProps;
}) => {
  const { ariaLabel, sx, iconLeft, iconRight, inputProps } = props;
  return (
    <TextInputContainer sx={sx}>
      {iconLeft ? (
        <IconContainer sx={{ marginRight: 1 }}>{iconLeft}</IconContainer>
      ) : null}
      <StyledInputBase
        inputProps={{ "aria-label": ariaLabel }}
        {...inputProps}
      />
      {iconRight ? (
        <IconContainer sx={{ marginLeft: 1 }}>{iconRight}</IconContainer>
      ) : null}
    </TextInputContainer>
  );
};

export default TextInput;
